import {
  Component,
  OnInit,
  Input,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { AppService } from "../app.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-link-renderer",
  template: `
    <span title="{{ ellipsesTitle }}">
      <a
        class="data-cell-link"
        *ngIf="linkObj.url != '' && !isLegacyLink && target == ''"
        routerLink="{{ linkObj.url }}"
        routerLinkActive="active"
      >
        <span
          *ngIf="showTooltip"
          nz-tooltip
          nzTooltipTitle="{{ linkObj.tooltipText }}"
          [innerHtml]="linkObj.displayText | textEllipsis: 110"
        ></span>
        <span
          *ngIf="!showTooltip"
          [innerHtml]="linkObj.displayText | textEllipsis: 110"
        ></span>
      </a>
      <a
        class="data-cell-link"
        *ngIf="linkObj.url != '' && !isLegacyLink && target != ''"
        target="{{ target }}"
        routerLink="{{ linkObj.url }}"
        routerLinkActive="active"
      >
        <span
          *ngIf="showTooltip"
          nz-tooltip
          nzTooltipTitle="{{ linkObj.tooltipText }}"
          [innerHtml]="linkObj.displayText | textEllipsis: 110"
        ></span>
        <span
          *ngIf="!showTooltip"
          [innerHtml]="linkObj.displayText | textEllipsis: 110"
        ></span>
      </a>
      <a
        class="data-cell-link"
        target="{{ target }}"
        *ngIf="linkObj.url != '' && isLegacyLink"
        href="{{ linkObj.url }}"
      >
        <span
          *ngIf="showTooltip"
          nz-tooltip
          nzTooltipTitle="{{ linkObj.tooltipText }}"
          [innerHtml]="linkObj.displayText | textEllipsis: 110"
        ></span>
        <span
          *ngIf="!showTooltip"
          [innerHtml]="linkObj.displayText | textEllipsis: 110"
        ></span>
      </a>
      <span *ngIf="linkObj.url == ''" class="data-cell-link">
        <span
          *ngIf="showTooltip"
          nz-tooltip
          nzTooltipTitle="{{ linkObj.tooltipText }}"
          [innerHtml]="linkObj.displayText | textEllipsis: 110"
        ></span>
        <span
          *ngIf="!showTooltip"
          [innerHtml]="linkObj.displayText | textEllipsis: 110"
        ></span>
      </span>
    </span>
  `,
  styles: [],
})
export class LinkRendererComponent implements OnInit {
  @Input() linkObj: any;
  @Input() docId: number;
  @ViewChild(TemplateRef) template: TemplateRef<{}>;
  target = "";
  showTooltip = null;
  legacyUrl: string = window.caUrl;
  isLegacyLink: boolean;
  ellipsesTitle = "";

  constructor(
    private appService: AppService,
    private router: Router,
  ) {}

  ngOnInit() {
    this.target = this.linkObj.target === "new" ? "_blank" : "";
    if (!this.linkObj.displayText) {
      this.linkObj.displayText = "";
    }
    this.showTooltip =
      this.linkObj.displayText.length > 110 ||
      this.linkObj.tooltipText !== undefined
        ? true
        : false;
    this.linkObj.tooltipText =
      this.linkObj.tooltipText !== undefined
        ? this.linkObj.tooltipText
        : this.linkObj.displayText;
    this.isLegacyLink = this.linkObj.url.includes(this.legacyUrl);
    setTimeout(() => {
      const outter =
        this.template.elementRef.nativeElement.nextSibling.offsetWidth;
      if (this.template.elementRef.nativeElement.nextSibling.lastElementChild) {
        const inner =
          this.template.elementRef.nativeElement.nextSibling.lastElementChild
            .offsetWidth;
        if (outter < inner) {
          this.ellipsesTitle = this.linkObj.displayText;
        }
      }
    }, 10);
  }
}
